import request from "../../utils/api";

export const whoami = params => {
  return request("v1/sellers/me", {
    params
  });
};
